import { spaceCategories } from "_constants";
import naturalSort from "javascript-natural-sort";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const defaultTransform = (res) => res;
const defaultSort = (a, b, dir) => {
  if (typeof a === "string") {
    return dir === "asc" ? a.localeCompare(b) : b.localeCompare(a);
  }

  return dir === "asc" ? a - b : b - a;
};

const categoryPosition = (category) => spaceCategories[category].position;

const sizeSort = (a, b, dir) => {
  const areaA = get(a, "area.value", null);
  const capacityA = get(a, "capacity.value", null);
  const areaB = get(b, "area.value", null);
  const capacityB = get(b, "capacity.value", null);

  if (areaA < areaB) return dir === "asc" ? -1 : 1;
  if (areaA > areaB) return dir === "asc" ? 1 : -1;
  if (capacityA < capacityB) return dir === "asc" ? -1 : 1;
  if (capacityA > capacityB) return dir === "asc" ? 1 : -1;

  return 0;
};

const sort = (spaces, path, dir, transform = defaultTransform, sortFn = defaultSort) =>
  [...spaces].sort((a, b) => {
    const aValue = transform(get(a, path, isEmpty(path) ? a : null));
    const bValue = transform(get(b, path, isEmpty(path) ? b : null));

    return (
      sortFn(aValue, bValue, dir) ||
      defaultSort(categoryPosition(a.category), categoryPosition(b.category), "asc") ||
      defaultSort(a.name, b.name, "asc")
    );
  });

const category = (spaces, dir) => sort(spaces, "category", dir, categoryPosition);
const floor = (spaces, dir) =>
  sort(
    spaces,
    "floor",
    dir,
    defaultTransform,
    dir === "asc" ? (a, b) => naturalSort(a, b) : (a, b) => naturalSort(b, a)
  );
const name = (spaces, dir) => sort(spaces, "name", dir);
const price = (spaces, dir) => sort(spaces, "prices", dir, (p) => (p.length > 0 ? p[0].value : 0));
const size = (spaces, dir) => sort(spaces, [], dir, defaultTransform, sizeSort);
const minContractLength = (spaces, dir) =>
  sort(spaces, "prices", dir, (p) =>
    p.length > 0 && p[0].minContractLength ? p[0].minContractLength.value : 0
  );
const status = (spaces, dir) => sort(spaces, "status", dir);
const availableFrom = (spaces, dir) =>
  sort(spaces, "availableFrom", dir, (d) => (d ? new Date(d) : null)); // eslint-disable-line
const leaseholders = (spaces, dir) =>
  sort(spaces, "leaseholders", dir, (l) =>
    l && l.length > 0 ? new Date(l[0].expirationDate) : null
  ); // eslint-disable-line

const sortFns = {
  floor,
  category,
  name,
  size,
  availableFrom,
  price,
  leaseholders,
  status,
  minContractLength,
};

const spaceSort = (key) => (spaces, dir) => sortFns[key](spaces, dir);

export default spaceSort;
